import { render, staticRenderFns } from "./AnnotationDetails.vue?vue&type=template&id=78659bd9&scoped=true&"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js&"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/annotation_details.scss?vue&type=style&index=0&id=78659bd9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78659bd9",
  null
  
)

export default component.exports